import { useSelector } from "react-redux";

export const checkCrud = (entityName: string, crudName: string, userInfo: any) => {
    if (userInfo) {
        const roles = userInfo.UserRoles || userInfo.userRoles;
        const entityRole = roles?.find(r => { return r.name.toLowerCase() === entityName.toLowerCase() });
        if (entityRole) {
            const crudRole = entityRole?.crud?.find(c => { return c === crudName });
            if (crudRole) {
                return true;
            }
        }
    }
    return false;
}

export const checkAdditionalRole = (entityName: string, userInfo: any) => {
    if (userInfo) {
        const roles = userInfo.UserRoles;
        const entityRole = roles?.find(r => { return r.name.toLowerCase() === entityName.toLowerCase() });
        if (entityRole && entityRole.isAuthorizedForAdditionalRole) {
            return true;
        }
    }
    return false;
}